import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      meta: {
        breadcrumb: [{ text: 'Home' }],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login'),
    },
    /* ---------------------------------------
      - Devs
    --------------------------------------- */
    {
      path: '/dev/bonus',
      name: 'Bonificações',
      component: () => import('@/views/dev/Bonus'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Bonificações' }],
      },
    },
    {
      path: '/dev/integrations',
      name: 'Integrações',
      component: () => import('@/views/dev/Integrations'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Integrations' }],
      },
    },
    {
      path: '/dev/logs',
      name: 'Logs',
      component: () => import('@/views/dev/Logs'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Logs' }],
      },
    },
    {
      path: '/dev/tools',
      name: 'Tools',
      component: () => import('@/views/dev/Tools'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Logs' }],
      },
    },
    /* ---------------------------------------
      - Slas
    --------------------------------------- */
    {
      path: '/sla/messages',
      name: 'SLAs Messages',
      component: () => import('@/views/sla/SlaMessages'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'SLAs' }, { text: 'Messages' }],
      },
    },
    {
      path: '/sla/history',
      name: 'SLAs History',
      component: () => import('@/views/sla/SlaHistory'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'SLAs' }, { text: 'Messages' }],
      },
    },
    /* ---------------------------------------
      - Fundação
    --------------------------------------- */
    {
      path: '/fnd/groups',
      name: 'groups',
      component: () => import(/* webpackChunkName: "fnd" */ '@/views/foundation/Groups'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Groups' }],
      },
    },
    {
      path: '/fnd/menu',
      name: 'menus',
      component: () => import(/* webpackChunkName: "fnd" */ '@/views/foundation/Menus'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Menus' }],
      },
    },
    {
      path: '/fnd/rules',
      name: 'rules',
      component: () => import(/* webpackChunkName: "fnd" */ '@/views/foundation/Rules'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Rules' }],
      },
    },
    {
      path: '/fnd/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "fnd" */ '@/views/foundation/Users'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Foundation' }, { text: 'Users' }],
      },
    },
    /* ---------------------------------------
      - Pedidos
    --------------------------------------- */
    {
      path: '/orders',
      name: 'Orders',
      component: () => import('@/views/orders/Orders'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Orders' }],
      },
    },
    {
      path: '/orders-boleto-pix',
      name: 'OrderPix',
      component: () => import('@/views/orders/OrdersPix'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Orders Boleto e Pix' }],
      },
    },
    {
      path: '/orders-credit-card',
      name: 'OrdersCreditCard',
      component: () => import('@/views/orders/OrdersCreditCard'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Orders Cartão de Crédito' }],
      },
    },
    {
      path: '/orders-waaw',
      name: 'OrdersWaaw',
      component: () => import('@/views/orders/OrderWaaw'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Orders Waaw' }],
      },
    },
    {
      path: '/orders-finantial',
      name: 'OrdersFinantial',
      component: () => import('@/views/orders/OrderFinancial'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Orders Finantial' }],
      },
    },
    {
      path: '/orders/:id/',
      name: 'Order',
      component: () => import('@/views/orders/Order'),
      props: true,
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Orders', to: '/Orders' }, { text: 'Order' }],
      },
    },
    /* ---------------------------------------
      - Sellers
    --------------------------------------- */
    {
      path: '/sellers',
      name: 'sellers',
      component: () => import('@/views/sellers/Sellers'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Sellers' }],
      },
    },
    {
      path: '/sellers/:id/freight',
      name: 'Sellers Freight',
      component: () => import('@/views/sellers/SellersFreight'),
      props: true,
      meta: {
        breadcrumb: [
          { text: 'Home', to: '/' },
          { text: 'Sellers', to: '/Sellers' },
          { text: 'Freight', to: '' },
        ],
      },
    },
    {
      path: '/sellers/:id/product',
      name: 'Sellers Product',
      component: () => import('@/views/sellers/SellersProduct'),
      props: true,
      meta: {
        breadcrumb: [
          { text: 'Home', to: '/' },
          { text: 'Sellers', to: '/Sellers' },
          { text: 'Product', to: '' },
        ],
      },
    },
    {
      path: '/sellers/:id/address',
      name: 'Sellers Address',
      component: () => import('@/views/sellers/SellersAddress'),
      props: true,
      meta: {
        breadcrumb: [
          { text: 'Home', to: '/' },
          { text: 'Sellers', to: '/Sellers' },
          { text: 'Address', to: '' },
        ],
      },
    },
    {
      path: '/sellers/:id/configuration',
      name: 'Sellers Config',
      component: () => import('@/views/sellers/SellerConfiguration'),
      props: true,
      meta: {
        breadcrumb: [
          { text: 'Home', to: '/' },
          { text: 'Sellers', to: '/Sellers' },
          { text: 'Configuration', to: '' },
        ],
      },
    },
    /* ---------------------------------------
      - Produtos
    --------------------------------------- */
    {
      path: '/product',
      name: 'product',
      component: () => import('@/views/products/Product'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Product' }],
      },
    },
    /* ---------------------------------------
      - Reports
    --------------------------------------- */
    {
      path: '/reports/order',
      name: 'Controle de Pedido',
      component: () => import('@/views/reports/OrdersDateReport'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Reports' }, { text: 'Order' }],
      },
    },
    {
      path: '/reports/stock',
      name: 'Consistência de Estoque',
      component: () => import('@/views/reports/StockCheck'),
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Reports' }, { text: 'Stock' }],
      },
    },
    /* ---------------------------------------
      - Financeiro
    --------------------------------------- */
    {
      path: '/financial/consolidated',
      name: 'Financeiro',
      component: () => import('@/views/financial/ConsolidatedMonthly'),
    },
    {
      path: '/financial/orders',
      name: 'Notas por Pedidos',
      component: () => import('@/views/financial/OrderConsolidatedReport'),
    },
    {
      path: '/financial/orders-history',
      name: 'Historico de Ordens',
      component: () => import('@/views/financial/OrderHistory'),
    },
    {
      path: '/financial/monthly-entries',
      name: 'Pagamentos Mensais',
      component: () => import('@/views/financial/MonthlyEntries.vue'),
    },
    {
      path: '/financial/invoice-wirecard',
      name: 'Invoice Wirecard',
      component: () => import('@/views/financial/InvoiceWirecard'),
    },
    /* ---------------------------------------
      - Mensagens
    --------------------------------------- */
    {
      path: '/messages/:orderIdMarketplace',
      name: 'Messages by Order Id',
      component: () => import('@/views/messages/Messages'),
      props: true,
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Central de Mensagens' }],
      },
    },
    {
      path: '/messages/:orderIdMarketplace/new',
      name: 'New Messages',
      component: () => import('@/views/messages/Messages'),
      props: true,
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Central de Mensagens' }],
      },
    },
    {
      path: '/messages/',
      name: 'messages',
      component: () => import('@/views/messages/Messages'),
      props: true,
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Central de Mensagens' }],
      },
    },
    /* ---------------------------------------
      - Bonus
    --------------------------------------- */
    {
      path: '/bonus/',
      name: 'bonus',
      component: () => import('@/views/bonus/Bonus'),
      props: true,
      meta: {
        breadcrumb: [{ text: 'Home', to: '/' }, { text: 'Bonificações' }],
      },
    },
    /* ---------------------------------------
      - Erro 404
    --------------------------------------- */
    {
      path: '*',
      name: '404',
      component: () => import('@/views/NotFoundComponent'),
    },
  ],
})
